module.exports = __webpack_public_path__ + "images/9bb748fb452eaec7e4f6493acdb83ef8.manager.png";